<ng-container *ngIf="openInComponent">
  <a
    [ae2Ga4Event]="'call_to_action'"
    [ga4Params]="{
      event_type: 'interaction',
      journey: 'reserva',
      section: 'menu',
      element_type: 'botao',
      element_label: 'reservar aulas'
    }"
    class="nameUnit"
    (click)="openPopOver()"
  >
    reservar aulas
  </a>
</ng-container>
<ng-container *ngIf="!openInComponent">
  <a
    [ae2Ga4Event]="'call_to_action'"
    [ga4Params]="{
      event_type: 'interaction',
      journey: 'reserva',
      section: 'menu',
      element_type: 'botao',
      element_label: 'reservar aulas'
    }"
    class="nameUnit"
  >
    reservar aulas
  </a>
</ng-container>
